<template>
	<section>
		<fieldset>
			<div class="field-title mb-3">
		    	<div class="legend">Selecione o tipo de relatório</div>
		    </div>
			
			<div class="container-fluid">
				<div class="row mb-3">
					<div class="col-12">
						<div class="form-check">
							<label class="form-check-label" for="type2">
								<input type="radio" v-model="type" id="type2" class="form-check-input" value="Detalhamento">
								<strong>Detalhamento</strong>
								&nbsp;
								<small>Gera a relação completa com seu horário individual.</small>
							</label>
						</div>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-12">
						<div class="form-check">
							<label class="form-check-label" for="type4">
								<input type="radio" v-model="type" id="type4" class="form-check-input" value="Fora-do-horario">
								<strong>Fora do horário de atendimento</strong>
								&nbsp;
								<small>Cria uma planílha com informações das ligações fora do horário de atendimento.</small>
							</label>
						</div>
					</div>
				</div>

				<div class="row mb-3">
					<div class="col-12">
						<div class="form-check">
							<label class="form-check-label" for="type5">
								<input type="radio" v-model="type" id="type5" class="form-check-input" value="0800">
								<strong>0800</strong>
								&nbsp;
								<small>Gera um relatório de atendimento 0800.</small>
							</label>
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<div class="d-flex flex-row-reverse bd-highlight">
			<router-link v-if="type" :to="{name: 'rel_filtro', params: { relatorio: type } }" class="btn btn-sm btn-primary">Próximo</router-link>
		</div>

	</section>
</template>

<script>
	export default {
		name: 'Select',
		data() { return { type: null }},
	};
</script>

<style>
</style>